import React, {Component} from 'react';
import {TableWrapper} from './components';
import PropTypes from 'prop-types';

class Table extends Component {
  render() {
    return(
      <TableWrapper black={this.props.black} center={this.props.center} hover={this.props.hover} maxNewsWidth={this.props.maxNewsWidth}>
        {this.props.children}
      </TableWrapper>
    )
  }
}
Table.propTypes = {
  children: PropTypes.node
}

export default Table;



// WEBPACK FOOTER //
// ./src/components/table/index.js